<template>
  <div>
    <v-card
      elevation="1"
      class="pa-4 pa-sm-8"
      :style="{ borderRadius: '16px' }"
    >
      <v-row no-gutters>
        <v-col cols="12" class="pb-6">
          <div class="d-flex justify-space-between align-center pb-1">
            <h2>บรรยากาศการทำงาน</h2>
            <v-btn text color="primary" @click="goToImageAndVideoPage" rounded>
              ดูทั้งหมด
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </div>

          <div
            v-if="
              businessMedia.img.length > 0 || businessMedia.video.length > 0
            "
          >
            <v-row dense justify="center">
              <v-col
                v-for="video in businessMedia.video"
                :key="video.file_url || video.src"
                cols="12"
                class="text-center"
              >
                <v-card elevation="0">
                  <video
                    v-if="
                      video.file_url &&
                      video.file_name &&
                      video.type === 'attached'
                    "
                    :src="video.file_url || video.src"
                    controls
                    width="100%"
                    height="auto"
                  ></video>
                  <iframe
                    :src="getYouTubeEmbedURL(video.file_url)"
                    frameborder="0"
                    allowfullscreen
                    width="100%"
                    class="media-ratio"
                    height="100%"
                    v-else-if="video.file_url && video.type === 'embedded'"
                  ></iframe>
                </v-card>
              </v-col>

              <v-row
                no-gutters
                v-if="businessMedia.img.some((image) => image.file_url)"
              >
                <v-col
                  v-for="(image, index) in businessMedia.img.slice(0, 3)"
                  :key="index || image.src"
                  cols="12"
                  md="3"
                  class="d-flex align-center"
                >
                  <v-img
                    v-if="image.file_url"
                    :src="image.file_url"
                    :alt="image.file_name || 'Image'"
                    width="350"
                    height="200"
                    contain
                    @click="openImageDialog(image)"
                  ></v-img>
                </v-col>
              </v-row>

              <v-col
                v-if="
                  businessMedia.img.length > 4 && businessMedia.img[4].file_url
                "
                cols="12"
                md="3"
                class="d-flex align-center"
              >
                <v-img
                  :src="
                    businessMedia.img[4].file_url || businessMedia.img[4].src
                  "
                  :alt="businessMedia.img[4].file_name || 'Image'"
                  width="350"
                  height="200"
                  contain
                  @click="openCarouselDialog"
                >
                  <template>
                    <div
                      class="d-flex justify-center align-center"
                      style="width: 100%; height: 100%; position: relative"
                    >
                      <div
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          text-align: center;
                          color: white;
                          background-color: rgba(0, 0, 0, 0.5);
                          padding: 90px;
                          border-radius: 5px;
                          z-index: 10;
                        "
                      >
                        <span style="font-size: 20px"
                          >+{{ businessMedia.img.length - 4 }}</span
                        >
                      </div>
                    </div>
                  </template>
                </v-img>
              </v-col>
            </v-row>

            <v-dialog
              v-model="carouselDialog"
              max-width="800px"
              @click:outside="closeDialog"
              style="z-index: 2500"
            >
              <v-carousel v-model="carouselIndex" hide-delimiter-background>
                <v-carousel-item
                  v-for="(image, index) in businessMedia.img"
                  :key="index"
                >
                  <v-img
                    :src="image.file_url || image.src"
                    :alt="image.file_name || 'Image'"
                  ></v-img>
                </v-carousel-item>
              </v-carousel>
            </v-dialog>

            <v-dialog
              v-model="imageDialog"
              max-width="800px"
              style="z-index: 2500"
            >
              <v-img
                :src="selectedImage?.file_url || selectedImage?.src"
              ></v-img>
            </v-dialog>
          </div>

          <!-- No images or videos available -->
          <div v-else class="text-detail pl-3 py-7">
            <v-col cols="12" style="text-align: -webkit-center">
              <v-img
                src="@/assets/no_news_data.png"
                :aspect-ratio="$vuetify.breakpoint.xsOnly ? '1' : '4'"
                contain
                :width="$vuetify.breakpoint.mdAndUp ? '140px' : '95px'"
                :height="$vuetify.breakpoint.mdAndUp ? '120px' : '80px'"
              ></v-img>
            </v-col>
            <v-col cols="12" class="text-center">
              <p style="font-weight: 700">ไม่พบรายการรูปภาพและวิดีโอ</p>
            </v-col>
          </div>
        </v-col>
      </v-row>
      <!-- Modal or Image/Video Viewer Component -->
      <ViewImageAndVideo
        v-if="showImageAndVideo"
        :businessMedia="businessMedia"
      />
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ViewImageAndVideo from "../../ImageAndVideo/ImageAndVideo.vue";

export default {
  name: "CompanySettingComponent",
  props: {
    business_data: Object,
    showProfileAddSuccess: Boolean,
  },
  components: {
    ViewImageAndVideo,
  },
  data() {
    return {
      businessDetails: {}, // To store the business details
      businessMedia: {
        img: [],
        video: [],
      },
      showImageAndVideo: false,
      imageDialog: false,
      selectedImage: null,
      carouselDialog: false,
      carouselIndex: 0,
    };
  },
  mounted() {
    this.fetchBusinessDetails();
    this.fetchBusinessMedia();
  },

  computed: {
    ...mapGetters({
      position_role: "position_role",
      user: "user",
    }),
    allImages() {
      return [...(this.businessMedia.img || [])];
    },
    allVideos() {
      return [...(this.businessMedia.video || [])];
    },
  },
  methods: {
    async fetchBusinessDetails() {
      try {
        const businessId = localStorage.getItem("business_id");
        if (!businessId) {
          console.error("Business ID is not available in localStorage.");
          return;
        }

        const response = await this.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/show-business/${businessId}`
        );

        if (response.data.success) {
          this.businessDetails = response.data.data;
        } else {
          console.error(
            "Failed to fetch business details:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error fetching business details:", error);
      }
    },
    async fetchBusinessMedia() {
      try {
        const businessId = localStorage.getItem("business_id");

        const response = await this.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/business/public/business-media/${businessId}`
        );

        if (response.data.success) {
          const { img, video } = response.data.data;
          this.businessMedia.img = img || [];
          this.businessMedia.video = video || [];
        } else {
          console.error(
            "Failed to fetch business media:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error fetching business media:", error);
      }
    },
    goToImageAndVideoPage() {
      this.$router.push("/business_profile/media");
    },
    path_file(filePath) {
      return `${process.env.VUE_APP_BACKEND}${filePath}`;
    },
    getYouTubeEmbedURL(url) {
      let videoId;
      if (url.includes("youtube.com")) {
        videoId = new URLSearchParams(new URL(url).search).get("v");
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];
      }
      return `https://www.youtube-nocookie.com/embed/${videoId}`;
    },

    openImageDialog(image) {
      this.selectedImage = image;
      this.imageDialog = true;
    },
    openCarouselDialog() {
      this.carouselIndex = 4;
      this.carouselDialog = true;
    },
    closeDialog() {
      this.carouselDialog = false;
    },
  },
};
</script>
<style scoped>
.text-detail {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

.text-address {
  font-size: 14px;
  color: #4a4a4a;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-line;
  text-align: center;
  margin: auto;
}

.text-section {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}

.v-card {
  background: #fff;
  border-radius: 8px;
}

.v-avatar {
  border: 2px solid #ddd;
  margin-top: -70px;
  z-index: 1;
}

.v-img {
  border-radius: 8px;
}

.text-not-authority {
  font-size: 16px;
  color: #f44336;
}

.header-style {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}
.media-ratio {
  aspect-ratio: 16/9;
}
</style>
